/* Limited Lingerie — "Buy 2, save 15%" bundle card (PDP)
   Drives the real `quantity` input already inside the product form;
   does not introduce a second source of truth for quantity. */
(function () {
  function syncCard(card, qty) {
    var qualifies = qty >= 2;
    card.setAttribute('data-bundle-state', qualifies ? 'qualifying' : 'default');

    var pill = card.querySelector('[data-bundle-pill]');
    var headline = card.querySelector('[data-bundle-headline]');
    if (pill) pill.textContent = qualifies ? pill.getAttribute('data-text-active') : pill.getAttribute('data-text-default');
    if (headline) headline.textContent = qualifies ? headline.getAttribute('data-text-active') : headline.getAttribute('data-text-default');

    card.querySelectorAll('[data-bundle-qty]').forEach(function (btn) {
      var isSelected = (qualifies && btn.getAttribute('data-bundle-qty') === '2') || (!qualifies && btn.getAttribute('data-bundle-qty') === '1');
      btn.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
    });
  }

  function getQtyInput(card) {
    var form = card.closest('form');
    return form ? form.querySelector('[name="quantity"]') : null;
  }

  function setQty(card, qty) {
    var input = getQtyInput(card);
    if (!input) return;
    input.value = qty;
    input.dispatchEvent(new Event('change', { bubbles: true }));
    syncCard(card, qty);
  }

  function initCard(card) {
    card.querySelectorAll('[data-bundle-qty]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        setQty(card, parseInt(btn.getAttribute('data-bundle-qty'), 10));
      });
    });

    var input = getQtyInput(card);
    if (input) {
      input.addEventListener('change', function () {
        syncCard(card, parseInt(input.value, 10) || 1);
      });
      syncCard(card, parseInt(input.value, 10) || 1);
    }
  }

  function init() {
    document.querySelectorAll('[data-ll-bundle]').forEach(initCard);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
